/* Bone Tide — dive zone behaviour: colour swatches, hover zoom, scroll reveal */
(function () {
  'use strict';


  // ---- bubbles ----
  function bubbles(root) {
    var box = root.querySelector('.btz-bubbles');
    if (!box || box.childElementCount) return;
    var n = Math.min(26, Math.round(root.offsetWidth / 60)) || 14;
    for (var i = 0; i < n; i++) {
      var b = document.createElement('i');
      var size = 4 + Math.random() * 11;
      b.style.left = (Math.random() * 100) + '%';
      b.style.width = size + 'px';
      b.style.height = size + 'px';
      b.style.setProperty('--bx', (Math.random() * 60 - 30) + 'px');
      b.style.animationDuration = (9 + Math.random() * 12) + 's';
      b.style.animationDelay = (-Math.random() * 18) + 's';
      b.style.opacity = 0.25 + Math.random() * 0.5;
      box.appendChild(b);
    }
  }

  function init(root) {
    bubbles(root); pruneDead(root);
    // ---- colour swatch swapping ----
    root.querySelectorAll('[data-pgroup]').forEach(function (group) {
      var main = group.querySelector('.btz-main');
      if (!main) return;
      var thumbs = group.querySelectorAll('.btz-thumb');
      if (!thumbs.length) return;

      function markActive(el) {
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === el); });
      }
      // mark whichever swatch matches the image currently shown
      thumbs.forEach(function (t) {
        t.addEventListener('click', function (e) {
          e.preventDefault();
          var full = t.getAttribute('data-full');
          if (full) {
            main.removeAttribute('srcset');
            main.setAttribute('src', full);
          }
          var zoom = t.getAttribute('data-zoom');
          if (zoom) main.setAttribute('data-zoom-src', zoom);
          main.setAttribute('alt', t.getAttribute('alt') || main.alt);
          main.style.transform = '';
          // keep the product link pointed at the chosen colour
          var link = main.closest('a');
          var href = t.getAttribute('data-href');
          if (link && href) link.setAttribute('href', href);
          var buy = group.parentElement && group.parentElement.querySelector('.btz-madd, .btz-add');
          if (buy && href) buy.setAttribute('href', href);
          markActive(t);
        });
      });
    });

    // ---- hover zoom on the featured image ----
    root.querySelectorAll('.btz-zoom').forEach(function (z) {
      var img = z.querySelector('.btz-hero');
      if (!img) return;
      var loaded = false;

      z.addEventListener('mouseenter', function () {
        if (loaded) return;
        var big = img.getAttribute('data-zoom-src');
        if (big) {                       // only fetch the 2048px file when someone actually zooms
          var pre = new Image();
          pre.onload = function () { img.removeAttribute('srcset'); img.src = big; };
          pre.src = big;
        }
        loaded = true;
      });
      z.addEventListener('mousemove', function (e) {
        var r = z.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
        img.style.transform = 'scale(2.4)';
      });
      z.addEventListener('mouseleave', function () {
        img.style.transform = '';
        img.style.transformOrigin = 'center';
      });
    });

    // ---- scroll reveal ----
    var items = root.querySelectorAll('.reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    items.forEach(function (el) { io.observe(el); });
  }

  // ---- image safety net ----
  // If a transparent cut-out hasn't been uploaded yet, fall back to the normal
  // Shopify product photo (data-fb). If THAT is missing too, hide the swatch.
  function pruneDead(root) {
    root.querySelectorAll('.btz-main, .btz-thumb').forEach(function (t) {
      function recover() {
        var fb = t.getAttribute('data-fb');
        if (fb && t.getAttribute('src') !== fb) {
          t.removeAttribute('srcset');
          t.setAttribute('src', fb);
          var ff = t.getAttribute('data-fbfull');
          if (ff) { t.setAttribute('data-full', ff); t.setAttribute('data-zoom', ff); }
          t.setAttribute('data-zoom-src', ff || fb);
          return;
        }
        if (t.classList.contains('btz-thumb')) t.classList.add('is-dead');
      }
      if (t.complete && t.naturalWidth === 0) { recover(); return; }
      t.addEventListener('error', recover);
    });
  }

  function boot() { document.querySelectorAll('[data-btz]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  // re-init when the theme editor re-renders a section
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-btz]').forEach(init);
  });
})();

/* ---------- Bone Tide submarine cursor: ambience only, NO game ----------
   Ported from submarine-cursor-prototype.html. Kept: cursor-follow with dive lag,
   tilt + flip to face travel, spinning propeller that speeds up with the sub,
   headlight beam that reaches further with depth, exhaust bubbles, wake streaks,
   and a small school of fish that scatters when the sub gets close.
   Removed: net, sharks, torpedoes, bones/HUD, modals. Nothing here is clickable. */
(function () {
  'use strict';
  if (!window.matchMedia || !window.requestAnimationFrame) return;
  if (!matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  if (matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  if (window.innerWidth < 900) return;
  if (window.__btzSub) return;

  var SUB = '<svg viewBox="0 0 300 150" xmlns="http://www.w3.org/2000/svg" overflow="visible">'
    + '<defs>'
    + '<linearGradient id="btzbeam" x1="0" y1="0" x2="1" y2="0">'
    + '<stop offset="0" stop-color="#fffdf2" stop-opacity=".9"/>'
    + '<stop offset=".5" stop-color="#fff3b0" stop-opacity=".45"/>'
    + '<stop offset="1" stop-color="#fff3b0" stop-opacity="0"/></linearGradient>'
    + '<radialGradient id="btzlamp" cx=".42" cy=".4" r=".62">'
    + '<stop offset="0" stop-color="#ffffff"/><stop offset=".38" stop-color="#fff8d2"/>'
    + '<stop offset="1" stop-color="#ffcf52"/></radialGradient>'
    + '<radialGradient id="btzglow" cx=".5" cy=".5" r=".5">'
    + '<stop offset="0" stop-color="#fff4bf" stop-opacity=".95"/>'
    + '<stop offset="1" stop-color="#fff4bf" stop-opacity="0"/></radialGradient>'
    + '</defs>'
    + '<g class="bg" opacity=".9"><path d="M243,86 L300,56 L300,116 Z" fill="url(#btzbeam)"/></g>'
    + '<line x1="36" y1="86" x2="20" y2="86" stroke="#22303a" stroke-width="4"/>'
    + '<g class="pr">'
    + '<path d="M13,86 Q4,70 13,55 Q22,70 13,86 Z" fill="#c4d2db" stroke="#22303a" stroke-width="2.5" stroke-linejoin="round"/>'
    + '<path d="M13,86 Q4,102 13,117 Q22,102 13,86 Z" fill="#a9bbc6" stroke="#22303a" stroke-width="2.5" stroke-linejoin="round"/>'
    + '<circle cx="13" cy="86" r="4.5" fill="#6f828d" stroke="#22303a" stroke-width="2.5"/></g>'
    + '<path d="M44,86 L26,58 L30,114 Z" fill="#E8892C" stroke="#22303a" stroke-width="4" stroke-linejoin="round"/>'
    + '<ellipse cx="132" cy="86" rx="100" ry="40" fill="#F2C14E" stroke="#22303a" stroke-width="5"/>'
    + '<path d="M40,92 Q132,140 224,92 Q132,116 40,92 Z" fill="#E0A93C"/>'
    + '<text class="hull" x="141" y="98" text-anchor="middle" font-family="BoneTideCo,Arial Narrow,Impact,sans-serif"'
    + ' font-size="27" letter-spacing="-2" fill="#8a6a1e" opacity=".9" transform="rotate(-9 141 91)">BT</text>'
    + '<rect x="112" y="30" width="46" height="34" rx="10" fill="#F2C14E" stroke="#22303a" stroke-width="5"/>'
    + '<path d="M136,32 L136,13 L151,13" fill="none" stroke="#22303a" stroke-width="8" stroke-linejoin="round" stroke-linecap="round"/>'
    + '<path d="M136,32 L136,13 L151,13" fill="none" stroke="#b7c6d0" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"/>'
    + '<circle cx="153" cy="13" r="4.5" fill="#bfe9f2" stroke="#22303a" stroke-width="3"/>'
    + '<circle cx="96" cy="90" r="12" fill="#bfe9f2" stroke="#22303a" stroke-width="5"/>'
    + '<circle cx="186" cy="90" r="11" fill="#bfe9f2" stroke="#22303a" stroke-width="5"/>'
    + '<circle class="gl" cx="238" cy="86" r="28" fill="url(#btzglow)" opacity=".28"/>'
    + '<path d="M241,75 Q244,86 241,97 Q224,98 223,86 Q224,74 241,75 Z" fill="url(#btzlamp)" stroke="#22303a" stroke-width="4.5" stroke-linejoin="round"/>'
    + '<circle cx="230" cy="82" r="3.4" fill="#fff" opacity=".95"/>'
    + '</svg>';

  var FC = [['#EF7C55','#E0663C'],['#3FB6C9','#2E97A8'],['#EFC15A','#E0A93C'],
            ['#C98BD6','#B06CC0'],['#7CC47F','#5AAD72'],['#E8A0B8','#D77E9C']];

  function fishSVG(c) {
    return '<svg viewBox="0 0 64 40" xmlns="http://www.w3.org/2000/svg">'
      + '<path d="M6,20 L22,9 L22,31 Z" fill="' + c[1] + '" stroke="#12303a" stroke-width="2.5" stroke-linejoin="round"/>'
      + '<ellipse cx="37" cy="20" rx="22" ry="13" fill="' + c[0] + '" stroke="#12303a" stroke-width="2.5"/>'
      + '<circle cx="50" cy="15" r="3.2" fill="#12303a"/></svg>';
  }

  function boot() {
    if (window.__btzSub) return;
    if (!document.querySelector('[data-btz]')) return;
    window.__btzSub = true;

    var sub = document.createElement('div');
    sub.className = 'btz-sub';
    sub.setAttribute('aria-hidden', 'true');
    sub.innerHTML = SUB;
    document.body.appendChild(sub);
    requestAnimationFrame(function () { sub.classList.add('on'); });

    var beam = sub.querySelector('.bg');
    var prop = sub.querySelector('.pr');
    // the prototype set these in CSS; SVG transform-box must be explicit or
    // the propeller spins around the viewBox origin instead of its own hub
    beam.style.transformBox = 'view-box';
    beam.style.transformOrigin = '240px 86px';
    prop.style.transformBox = 'view-box';
    prop.style.transformOrigin = '13px 86px';
    var propAnim = prop.animate(
      [{ transform: 'perspective(130px) rotateX(0deg)' },
       { transform: 'perspective(130px) rotateX(360deg)' }],
      { duration: 550, iterations: Infinity, easing: 'linear' });
    var propRate = 1;

    // ---- the school ----
    // The geometric placeholder fish are retired - the school and the lionfish are real
    // Lottie art now (see REEF LIFE at the end of this file). Put sizes back into this
    // array to bring the old ovals back.
    var SIZES = [];
    var fish = [];
    for (var i = 0; i < SIZES.length; i++) {
      var el = document.createElement('div');
      el.className = 'btz-fish';
      el.setAttribute('aria-hidden', 'true');
      el.style.width = SIZES[i] + 'px';
      el.innerHTML = fishSVG(FC[i % FC.length]);
      document.body.appendChild(el);
      fish.push({
        el: el, w: SIZES[i],
        x: Math.random() * innerWidth,
        y: 120 + Math.random() * Math.max(120, innerHeight - 240),
        vx: (Math.random() < 0.5 ? -1 : 1) * (0.45 + Math.random() * 0.55),
        vy: (Math.random() - 0.5) * 0.45,
        face: 1
      });
    }

    // <span>, not <div>: the storefront carries a `div:empty{display:none}` rule from
    // outside the theme, and an exhaust bubble is by definition an empty element.
    // As divs these were being hidden, which is why the sub had no bubbles or wake.
    function bubble(x, y) {
      var b = document.createElement('span');
      b.className = 'btz-bub2';
      var s = 3 + Math.random() * 5;
      b.style.cssText = 'left:' + (x - s / 2) + 'px;top:' + (y - s / 2) + 'px;width:' + s + 'px;height:' + s + 'px';
      document.body.appendChild(b);
      var rise = 28 + Math.random() * 46, drift = Math.random() * 22 - 11;
      b.animate([{ transform: 'translate(0,0)', opacity: .9 },
                 { transform: 'translate(' + drift + 'px,-' + rise + 'px)', opacity: 0 }],
                { duration: 850 + Math.random() * 750, easing: 'ease-out' })
       .onfinish = function () { b.remove(); };
    }

    function wake(x, y, ang) {
      var w = document.createElement('span');
      w.className = 'btz-wake';
      var len = 16 + Math.random() * 16;
      w.style.cssText = 'left:' + x + 'px;top:' + y + 'px;width:' + len + 'px';
      document.body.appendChild(w);
      var back = 22 + Math.random() * 16;
      w.animate([{ transform: 'rotate(' + ang + 'rad) translateX(0) scaleX(.6)', opacity: .5 },
                 { transform: 'rotate(' + ang + 'rad) translateX(' + (-back) + 'px) scaleX(1)', opacity: 0 }],
                { duration: 520 + Math.random() * 260, easing: 'ease-out' })
       .onfinish = function () { w.remove(); };
    }

    // The waterline is wherever the page says it is: the hero's wave band on a zone page
    // with a surface hero, otherwise the top of the dive itself. Never above the sticky
    // header - the sub has no business swimming over the nav.
    function waterTop() {
      var y = 0, r;
      var surf = document.querySelector('.btzh-surface');
      if (surf) { r = surf.getBoundingClientRect(); y = r.top + r.height * 0.42; }
      else {
        var wrap = document.querySelector('.btz-wrap');
        if (wrap) y = wrap.getBoundingClientRect().top;
      }
      var hdr = document.querySelector('#shopify-section-header') || document.querySelector('header');
      if (hdr) { r = hdr.getBoundingClientRect(); if (r.bottom > y) y = r.bottom; }
      y += 24;
      return y < 0 ? 0 : (y > innerHeight - 60 ? innerHeight - 60 : y);
    }

    var sx = innerWidth / 2, sy = innerHeight * 0.4, tx = sx, ty = sy;
    var hx = 1, hy = 0, faceT = 1, facing = 1, emitAcc = 0, moved = false;
    var hull = sub.querySelector('text.hull'), hullFace = 1;
    var idling = false, wanderX = sx, wanderY = sy, wanderAt = 0;

    addEventListener('mousemove', function (e) { tx = e.clientX; ty = e.clientY; moved = true; }, { passive: true });

    function loop() {
      // ---------- stay in the water ----------
      // Above the waterline the sub stops chasing and holds station just under the surface,
      // wandering to a new spot every couple of seconds the way the fish do, until the
      // cursor comes back down.
      var now = performance.now(), top = waterTop(), wx = tx, wy = ty;
      if (ty < top) {
        if (!idling) { idling = true; wanderAt = 0; }
        if (now >= wanderAt) {
          wanderX = sx + (Math.random() * 2 - 1) * 300;
          if (wanderX < 70) wanderX = 70;
          if (wanderX > innerWidth - 70) wanderX = innerWidth - 70;
          wanderY = top + 30 + Math.random() * 90;
          wanderAt = now + 1500 + Math.random() * 2200;
        }
        wx = wanderX; wy = wanderY;
      } else {
        idling = false;
      }
      if (wy < top) wy = top;

      var hdx = wx - sx, hdy = wy - sy, hd = Math.hypot(hdx, hdy);
      if (hd > 0.5) { hx += ((hdx / hd) - hx) * 0.18; hy += ((hdy / hd) - hy) * 0.18; }
      var hn = Math.hypot(hx, hy) || 1, nhx = hx / hn, nhy = hy / hn;
      if (nhx > 0.15) faceT = 1; else if (nhx < -0.15) faceT = -1;
      facing += (faceT - facing) * 0.15;

      // The whole sub is mirrored with scaleX to face travel, which mirrors the BT badge
      // along with it and prints it backwards. Counter-mirror the text about its own
      // centre - the badge sits at x=141, so the mirror axis is translate(282) scale(-1,1).
      var hf = facing < 0 ? -1 : 1;
      if (hull && hf !== hullFace) {
        hullFace = hf;
        hull.setAttribute('transform', hf < 0
          ? 'translate(282,0) scale(-1,1) rotate(-9 141 91)'
          : 'rotate(-9 141 91)');
      }

      var hfrac = Math.abs(nhx), pitch = Math.atan2(nhy, Math.abs(nhx)) * hfrac * hfrac;
      if (pitch > 0.5) pitch = 0.5; else if (pitch < -0.5) pitch = -0.5;
      var deg = pitch * (facing < 0 ? -1 : 1) * 180 / Math.PI;

      var psx = sx, psy = sy, FOLLOW = idling ? 8 : 150, MIND = idling ? 0 : 115;
      if (hd > FOLLOW) { var over = hd - FOLLOW; sx += (hdx / hd) * over * 0.11; sy += (hdy / hd) * over * 0.11; }
      else if (hd > 1 && hd < MIND) { var under = MIND - hd; sx -= (hdx / hd) * under * 0.10; sy -= (hdy / hd) * under * 0.10; }
      sub.style.transform = 'translate(' + (sx - 66) + 'px,' + (sy - 37) + 'px) rotate(' + deg + 'deg) scaleX(' + facing + ')';

      var depth = Math.min(1, Math.max(0, sy / innerHeight));
      beam.style.transform = 'scaleX(' + (0.8 + depth * 2.8) + ')';
      beam.style.opacity = (0.72 + depth * 0.24).toFixed(3);

      var speed = Math.hypot(sx - psx, sy - psy);
      var target = 1 + Math.min(2.2, speed * 0.15);
      propRate += (target - propRate) * 0.1;
      propAnim.playbackRate = propRate;

      emitAcc += speed;
      if (speed > 0.5 && emitAcc > 7) { emitAcc = 0; bubble(sx - nhx * 58 + (Math.random() * 10 - 5), sy - nhy * 58 + (Math.random() * 10 - 5)); }
      if (speed > 3 && Math.random() < 0.22) wake(sx - nhx * 38, sy - nhy * 38, Math.atan2(nhy, nhx));

      var R = 170, R2 = R * R;
      for (var k = 0; k < fish.length; k++) {
        var f = fish[k];
        var dx = f.x - sx, dy = f.y - sy, d2 = dx * dx + dy * dy;
        if (moved && d2 < R2) {
          var dd = Math.sqrt(d2) || 1, force = (R - dd) / R * 2.4;
          f.vx += (dx / dd) * force * 0.6; f.vy += (dy / dd) * force * 0.6;
        } else {
          f.vx += ((f.vx > 0 ? 0.5 : -0.5) - f.vx) * 0.01;
          f.vy += (Math.sin((f.x + f.y) / 220) * 0.3 - f.vy) * 0.02;
        }
        var sp = Math.hypot(f.vx, f.vy), MX = (moved && d2 < R2) ? 6.5 : 1.5;
        if (sp > MX) { f.vx *= MX / sp; f.vy *= MX / sp; }
        f.x += f.vx; f.y += f.vy;
        if (f.x < -80) f.x = innerWidth + 70;
        if (f.x > innerWidth + 80) f.x = -70;
        if (f.y < 60) f.y = innerHeight - 90;
        if (f.y > innerHeight - 40) f.y = 70;
        if (Math.abs(f.vx) > 0.2) f.face = f.vx < 0 ? -1 : 1;
        f.el.style.transform = 'translate(' + (f.x - f.w / 2) + 'px,' + (f.y - f.w * 0.3) + 'px) scaleX(' + f.face + ')';
      }

      requestAnimationFrame(loop);
    }
    loop();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ================= THE DIVE (v2) =================
   Fixed reef backdrop + scroll-driven depth + scroll bubbles + zoom on every shirt.
   Player and scene are both hosted in this store's own Content > Files, so there is no
   third-party CDN in the critical path. The Files URL is derived from a product cut-out
   already on the page, which is why none of this needed a Liquid change.
   Skipped on reduced-motion and under 900px (the scene is 646KB).
   ================================================= */
(function () {
  'use strict';
  if (!window.matchMedia || matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  if (window.innerWidth < 900) return;
  if (window.__btzDive) return;

  var SCENE = 'Underwater_Ocean_Fish_and_Turtle.json';
  var PLAYER = 'lottie_light.min.js';

  var REEF_START = 50;   // vh of travel. The box is 150vh tall and bottom-anchored, so the viewport is always inside it and no edge can ever show.
  // Water gets DARKER with depth, not lighter. The first cut faded the reef in from almost
  // nothing to full as you descended, and because the reef art is bright cyan the page
  // brightened on the way down - backwards, and Jessie spotted it. The veil now does the
  // heavy lifting: light at the surface, near-opaque at the seabed, so the reef arrives as a
  // silhouette out of the dark instead of as a light source.
  var DEEP_MIN = 0.32;   // veil just under the waterline - open, sunlit water
  var DEEP_MAX = 0.88;   // veil at the seabed - the reef reads as shape, not colour
  var REEF_MIN = 0.22;   // reef presence at the surface: a suggestion, far below you
  var REEF_MAX = 1.00;

  function filesBase() {
    var img = document.querySelector('.btz-main[src*="/cdn/shop/files/"]');
    return img ? img.getAttribute('src').split('?')[0].replace(/[^\/]+$/, '') : null;
  }

  // ---------- zoom on every shirt in the grid ----------
  function gridZoom(root) {
    root.querySelectorAll('.btz-mart').forEach(function (box) {
      var img = box.querySelector('.btz-ms');
      if (!img || box.querySelector('.btz-zwrap')) return;

      // wrap the link so the zoom transform never fights the drift animation on the img
      var link = img.closest('a') || img;
      var wrap = document.createElement('div');
      wrap.className = 'btz-zwrap';
      box.insertBefore(wrap, link);
      wrap.appendChild(link);

      var hint = document.createElement('span');
      hint.className = 'btz-mhint';
      hint.textContent = 'Hover to zoom';
      var pv = box.closest('.btz-pv') || box;
      pv.appendChild(hint);

      box.addEventListener('mousemove', function (e) {
        var r = box.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        wrap.style.transformOrigin = x + '% ' + y + '%';
        wrap.style.transform = 'scale(2.15)';
      });
      box.addEventListener('mouseleave', function () {
        wrap.style.transform = '';
        wrap.style.transformOrigin = 'center';
      });
    });
  }

  // ---------- bubbles that stream past while you scroll ----------
  function scrollBubbles() {
    var last = window.pageYOffset, acc = 0, ticking = false;

    function spawn(n) {
      for (var i = 0; i < n; i++) {
        var b = document.createElement('span');
        b.className = 'btz-sbub';
        var s = 3 + Math.random() * 8;
        b.style.cssText = 'left:' + (Math.random() * 100) + 'vw;top:' + (100 + Math.random() * 12) + 'vh;' +
                          'width:' + s + 'px;height:' + s + 'px';
        document.body.appendChild(b);
        var rise = 110 + Math.random() * 45, drift = Math.random() * 70 - 35;
        b.animate([{ transform: 'translate(0,0)', opacity: 0 },
                   { transform: 'translate(' + (drift * 0.4) + 'px,-30vh)', opacity: .75, offset: .25 },
                   { transform: 'translate(' + drift + 'px,-' + rise + 'vh)', opacity: 0 }],
                  { duration: 2200 + Math.random() * 1600, easing: 'linear' })
         .onfinish = function () { b.remove(); };
      }
    }

    addEventListener('scroll', function () {
      var y = window.pageYOffset;
      acc += Math.abs(y - last);
      last = y;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        // roughly one bubble per 90px travelled, capped so a flick of the wheel
        // does not dump a hundred elements into the DOM at once
        var n = Math.min(4, Math.floor(acc / 90));
        if (n > 0) { acc = 0; spawn(n); }
      });
    }, { passive: true });
  }

  function mount(base) {
    var wrap = document.querySelector('.btz-wrap');
    // Depth is measured over the DIVE only. The surface hero is a sibling above
    // .btz-wrap, so measuring the whole section would spend the first screen of
    // scroll "descending" while you were still looking at the beach.
    var zone = wrap;
    if (!wrap) return;

    var host = document.createElement('div');
    host.className = 'btz-lottie';
    host.setAttribute('aria-hidden', 'true');

    var reef = document.createElement('div');
    reef.className = 'btz-lottie-in';
    var surface = document.createElement('div');
    surface.className = 'btz-surface';
    var deep = document.createElement('div');
    deep.className = 'btz-deep';
    var floor = document.createElement('div');
    floor.className = 'btz-floor';

    host.appendChild(reef);
    host.appendChild(surface);
    host.appendChild(deep);
    host.appendChild(floor);
    document.body.appendChild(host);
    wrap.classList.add('has-lottie');

    window.lottie.loadAnimation({
      container: reef,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: base + SCENE,
      rendererSettings: { preserveAspectRatio: 'xMidYMid slice', progressiveLoad: true }
    }).addEventListener('DOMLoaded', function () {
      host.classList.add('on');
    });

    // ---------- depth: where you are in the zone is how deep you are ----------
    var ticking = false;
    function depth() {
      var r = zone.getBoundingClientRect();
      var vh = window.innerHeight;
      // 0 when the top of the zone meets the top of the screen,
      // 1 when the bottom of the zone meets the bottom of the screen
      var travel = r.height - vh;
      var p = travel > 0 ? (-r.top) / travel : (r.bottom < vh ? 1 : 0);
      p = p < 0 ? 0 : (p > 1 ? 1 : p);

      // ease so most of the reef arrives in the last stretch of the dive
      var reefP = Math.pow(p, 1.45);
      reef.style.transform = 'translate3d(0,' + ((1 - reefP) * REEF_START).toFixed(2) + 'vh,0)';
      // Fade the reef in as you descend. At the surface you are in open water and the
      // scene is only a suggestion in the dark; by the seabed it is fully present.
      // This is also what keeps the small gold subtitles legible up top - the reef
      // artwork is bright cyan, and no amount of dark veil over it reads as "deep".
      reef.style.opacity = (REEF_MIN + (REEF_MAX - REEF_MIN) * Math.pow(p, 1.25)).toFixed(3);
      surface.style.opacity = (1 - Math.pow(p, 0.75)).toFixed(3);
      deep.style.opacity = (DEEP_MIN + (DEEP_MAX - DEEP_MIN) * p).toFixed(3);
      // The backdrop has to be live behind the surface hero too: the hero's lower edge is
      // masked to transparent so the photo dissolves straight into open water. Keying this
      // to .btz-wrap instead pops the reef in at the seam, which reads as a hard line.
      var rv = (zone.closest('.bone-tide-dive-zone') || zone).getBoundingClientRect();
      host.style.visibility = (rv.bottom > 0 && rv.top < vh) ? 'visible' : 'hidden';
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; depth(); });
    }
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    depth();
  }

  function boot() {
    if (window.__btzDive) return;
    var root = document.querySelector('[data-btz]');
    if (!root) return;
    window.__btzDive = true;

    gridZoom(root);
    scrollBubbles();

    var base = filesBase();
    if (!base) return;               // cut-outs are off; keep the CSS water
    if (window.lottie) { mount(base); return; }
    var s = document.createElement('script');
    s.src = base + PLAYER;
    s.async = true;
    s.onload = function () { if (window.lottie) mount(base); };
    s.onerror = function () { document.querySelector('.btz-wrap').classList.remove('has-lottie'); };
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ================= SURFACE HERO =================
   Slow sink on the photo and a fade on the copy as you approach the waterline, so the
   beach falls away instead of just scrolling off. Decorative only: if none of this runs
   the hero is still a correct static band.

   Both offsets are written to the independent `translate` property, NOT `transform`.
   .btzh-bg already runs a keyframe animation on `transform`, and a running animation
   beats an inline style in the cascade — an inline transform here would silently do
   nothing. `translate` composes on top of it instead, and on .btzh-copy it leaves the
   translateY(-50%) centring alone.
   ================================================ */
(function () {
  'use strict';
  if (window.__btzHero) return;
  if (!window.matchMedia || matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  var hero = document.querySelector('[data-btzh]');
  if (!hero) return;
  window.__btzHero = true;

  var bg = hero.querySelector('.btzh-bg');
  var copy = hero.querySelector('.btzh-copy');
  var cue = hero.querySelector('.btzh-cue');
  var ticking = false;

  function frame() {
    var r = hero.getBoundingClientRect();
    if (r.bottom <= 0 || r.height <= 0) return;   // hero is behind you; leave it alone
    var p = -r.top / r.height;
    p = p < 0 ? 0 : (p > 1 ? 1 : p);

    // the photo sinks at a fraction of scroll speed, so the waterline rises to meet you
    if (bg) bg.style.translate = '0 ' + (p * 14).toFixed(2) + 'vh';
    if (copy) {
      copy.style.translate = '0 ' + (p * 7).toFixed(2) + 'vh';
      copy.style.opacity = Math.max(0, 1 - Math.pow(p, 0.85) * 1.15).toFixed(3);
    }
    if (cue) cue.style.opacity = (0.72 * Math.max(0, 1 - p * 3.2)).toFixed(3);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; frame(); });
  }
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  frame();
})();

/* ================= REEF LIFE =================
   Real fish, from Jessie's own Lottie set, in place of the geometric placeholders.

   - THE SCHOOL swims itself. "Fish Animation" has the traversal baked into its 240 frames,
     so it only needs placing, not animating. Its comp carries weed sprigs hard against the
     left and right edges, which is why the container is deliberately WIDER than the
     viewport - that pushes the sprigs off screen and leaves only open water and fish.
   - THE LIONFISH does not traverse. It hovers and fans its fins in place, so it is carried
     across on a CSS transition and then parked until the next pass. The art faces left, so
     a right-to-left crossing is its natural direction; going the other way mirrors it.

   Both ride inside the fixed reef backdrop, so they belong to the water rather than to the
   page, and both are skipped wherever the reef is skipped.
   ============================================= */
(function () {
  'use strict';
  if (!window.matchMedia || matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  if (window.innerWidth < 900) return;
  if (window.__btzLife) return;

  var SCHOOL = 'Fish_Animation.json';
  var LION = 'Lion_Fish.json';

  function filesBase() {
    var img = document.querySelector('.btz-main[src*="/cdn/shop/files/"]');
    return img ? img.getAttribute('src').split('?')[0].replace(/[^\/]+$/, '') : null;
  }

  function start() {
    var host = document.querySelector('.btz-lottie');
    if (!host || !window.lottie) return false;      // the reef has not mounted yet
    var base = filesBase();
    if (!base) return true;                          // cut-outs off; nothing to derive a URL from
    window.__btzLife = true;

    // The school is a PASS, not a permanent fixture. Left looping it read as an aquarium
    // rather than open water - Jessie: "waaaaay to frequent". The comp already contains one
    // full traversal, so it plays once, clears, and waits 30-45s before the next shoal.
    var school = document.createElement('span');
    school.className = 'btz-fishschool';
    school.setAttribute('aria-hidden', 'true');
    host.appendChild(school);
    var schoolAnim = window.lottie.loadAnimation({
      container: school, renderer: 'svg', loop: false, autoplay: false, path: base + SCHOOL,
      rendererSettings: { preserveAspectRatio: 'xMidYMid meet', progressiveLoad: true }
    });
    function schoolPass() {
      school.style.top = (14 + Math.random() * 34) + '%';
      school.style.opacity = '';           // let the stylesheet's resting opacity back in
      schoolAnim.goToAndPlay(0, true);
    }
    schoolAnim.addEventListener('complete', function () {
      school.style.opacity = '0';
      setTimeout(schoolPass, 30000 + Math.random() * 15000);
    });
    schoolAnim.addEventListener('DOMLoaded', function () {
      school.style.opacity = '0';
      setTimeout(schoolPass, 4000 + Math.random() * 6000);
    });

    var lion = document.createElement('span');
    lion.className = 'btz-lion';
    lion.setAttribute('aria-hidden', 'true');
    host.appendChild(lion);
    window.lottie.loadAnimation({
      container: lion, renderer: 'svg', loop: true, autoplay: true, path: base + LION,
      rendererSettings: { preserveAspectRatio: 'xMidYMid meet', progressiveLoad: true }
    });

    // A straight horizontal slide reads like a cardboard cut-out on a wire. The crossing is
    // driven per-frame instead so the fish can rise and sink on a slow sine as it travels -
    // two offset waves so the path never repeats convincingly. Horizontal speed stays linear;
    // only the depth wanders, which is what a real fish does.
    var lionRAF = null;
    function pass() {
      var rtl = Math.random() < 0.65;
      var dur = 26000 + Math.random() * 14000;
      var from = rtl ? innerWidth + 260 : -320;
      var to = rtl ? -320 : innerWidth + 260;
      var flip = rtl ? 1 : -1;
      var baseTop = 22 + Math.random() * 42;          // % of the viewport
      var amp = 5 + Math.random() * 7;                // how far it rises and sinks, in %
      var cycles = 1.6 + Math.random() * 1.4;         // how many rises across one crossing
      var phase = Math.random() * Math.PI * 2;
      var t0 = null;

      lion.style.transition = 'opacity 1.8s ease';
      lion.style.opacity = '0';

      function step(ts) {
        if (t0 === null) t0 = ts;
        var k = (ts - t0) / dur;
        if (k >= 1) {
          lion.style.opacity = '0';
          lionRAF = null;
          setTimeout(pass, 22000 + Math.random() * 28000);
          return;
        }
        var x = from + (to - from) * k;
        var y = Math.sin(phase + k * Math.PI * 2 * cycles) * amp;
        // nose down slightly when sinking, up when rising - derivative of the sine
        var tilt = Math.cos(phase + k * Math.PI * 2 * cycles) * cycles * 4 * flip;
        lion.style.transform = 'translate(' + x + 'px,' + y + 'vh) rotate(' + tilt.toFixed(2) +
                               'deg) scaleX(' + flip + ')';
        if (k > 0.03 && k < 0.94) lion.style.opacity = '.85';
        else if (k >= 0.94) lion.style.opacity = '0';
        lionRAF = requestAnimationFrame(step);
      }
      lion.style.top = baseTop + '%';
      lion.style.transform = 'translate(' + from + 'px,0) scaleX(' + flip + ')';
      lionRAF = requestAnimationFrame(step);
    }
    setTimeout(pass, 5000 + Math.random() * 7000);
    return true;
  }

  // The reef mounts asynchronously (it fetches its own scene), so wait for it rather than
  // racing it. Gives up after ~30s so a page without a reef never keeps a timer alive.
  var tries = 0;
  (function wait() {
    if (start()) return;
    if (++tries > 60) return;
    setTimeout(wait, 500);
  })();
})();


/* ===================================================================
   BONE TIDE - pin the reef creatures to a depth (added 2026-08-23)

   .btz-lion / .btz-fishschool are position:absolute but the spawn code
   appends them to .btz-lottie, which is position:FIXED - so they rode
   the viewport instead of sitting at a depth in the page.

   This re-parents them into .btz-life (an absolute layer inside the
   in-flow .btz-wrap) and converts their top to document px so nothing
   jumps. A MutationObserver catches each respawn on the rotation.
   =================================================================== */
(function () {
  'use strict';

  function init() {
    var wrap = document.querySelector('.btz-wrap');
    var host = document.querySelector('.btz-lottie');
    if (!wrap || !host) return false;

    var life = wrap.querySelector('.btz-life');
    if (!life) {
      life = document.createElement('div');
      life.className = 'btz-life';
      life.setAttribute('aria-hidden', 'true');
      wrap.appendChild(life);
    }

    function wrapOffset() {
      return wrap.getBoundingClientRect().top + window.scrollY;
    }

    function adopt(el) {
      if (el.dataset.btPinned) return;
      var vTop = el.getBoundingClientRect().top;
      var abs  = window.scrollY + vTop - wrapOffset();
      life.appendChild(el);
      el.style.top = abs + 'px';
      el.style.bottom = '';
      el.dataset.btPinned = '1';
    }

    host.querySelectorAll('.btz-lion,.btz-fishschool').forEach(adopt);

    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType === 1 && n.matches && n.matches('.btz-lion,.btz-fishschool')) adopt(n);
        });
      });
    }).observe(host, { childList: true });

    return true;
  }

  if (!init()) {
    var tries = 0;
    var t = setInterval(function () {
      if (init() || ++tries > 60) clearInterval(t);
    }, 250);
  }
})();
